import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import { useTheme } from '@paypalcorp/pp-react-theme';
import { V2CheckmarkSmIcon, V2ClockIcon, V2CriticalIcon, V2PreferredFilledIcon } from '@paypalcorp/pp-react-icons';
import clsx from 'clsx';
import '../__generated__/styles/badge.css';

var styles = {"ppvx_badge":"ppvx_badge___2-11-9","ppvx_badge--status":"ppvx_badge--status___2-11-9","ppvx_badge--type_feature":"ppvx_badge--type_feature___2-11-9","ppvx_badge--type_success":"ppvx_badge--type_success___2-11-9","ppvx_badge--type_warning":"ppvx_badge--type_warning___2-11-9","ppvx_badge--type_critical":"ppvx_badge--type_critical___2-11-9","ppvx_badge--type_neutral":"ppvx_badge--type_neutral___2-11-9","ppvx--v2":"ppvx--v2___2-11-9","ppvx--v1":"ppvx--v1___2-11-9","ppvx_badge--icon-left":"ppvx_badge--icon-left___2-11-9","ppvx_badge__icon":"ppvx_badge__icon___2-11-9","ppvx_badge--authorized":"ppvx_badge--authorized___2-11-9","ppvx_badge--in-progress":"ppvx_badge--in-progress___2-11-9","ppvx_badge--on-hold":"ppvx_badge--on-hold___2-11-9","ppvx_badge--favorite":"ppvx_badge--favorite___2-11-9","ppvx_badge--numeric":"ppvx_badge--numeric___2-11-9","ppvx_screenreader":"ppvx_screenreader___2-11-9","ppvx_body--no-scrolling":"ppvx_body--no-scrolling___2-11-9","ppvx_visible-only-in-context":"ppvx_visible-only-in-context___2-11-9","ppvx_text-ellipsis":"ppvx_text-ellipsis___2-11-9","ppvx_badge__icon-label":"ppvx_badge__icon-label___2-11-9"};

var _excluded = ["type", "status", "className", "theme", "leftIcon", "leftIconLabel", "children"],
    _excluded2 = ["className", "children", "label", "icon"];

var Badge = function (_ref) {
  var _clsx;

  var type = _ref.type,
      status = _ref.status,
      className = _ref.className,
      theme = _ref.theme,
      leftIcon = _ref.leftIcon,
      leftIconLabel = _ref.leftIconLabel,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _theme = useTheme('Badge', theme);

  /* istanbul ignore else */
  if (_theme !== 'v2') {
    console.warn('Badge 1.0 styles are deprecated. Use Badge 2.0 styles and refer to our Migration Guide on how to use 2.0 styles/components.');
  }

  var badgeClasses = clsx(styles.ppvx_badge, (_clsx = {}, _defineProperty(_clsx, styles["ppvx_badge--type_".concat(type)], type), _defineProperty(_clsx, styles["ppvx_badge--status"], status), _defineProperty(_clsx, styles['ppvx--v2'], _theme && _theme === 'v2'), _defineProperty(_clsx, styles["ppvx_badge--icon-left"], leftIcon), _clsx), className); //Badge with icon

  var ariaProps = {
    'aria-hidden': true
  };
  var badgeIcon = (leftIcon || leftIconLabel) && /*#__PURE__*/React.createElement("span", {
    className: styles.ppvx_badge__icon
  }, /*#__PURE__*/React.createElement(function Icon() {
    /* istanbul ignore next */
    if (type === 'critical') {
      return /*#__PURE__*/React.createElement(V2CriticalIcon, _extends({
        size: "xs"
      }, ariaProps));
    }

    return /*#__PURE__*/React.createElement(leftIcon, _extends({
      size: "xs"
    }, ariaProps));
  }, null), /*#__PURE__*/React.createElement("span", {
    className: styles["ppvx_badge__icon-label"]
  }, leftIconLabel)); // End badge with icon

  return /*#__PURE__*/React.createElement("span", _extends({
    className: badgeClasses
  }, rest), badgeIcon, children);
};

var AuthorizedBadge = function (props) {
  var badgeClasses = clsx(styles["ppvx_badge--authorized"], props.className);
  return /*#__PURE__*/React.createElement(BadgeComponent, _extends({}, props, {
    className: badgeClasses,
    icon: /*#__PURE__*/React.createElement(V2CheckmarkSmIcon, {
      size: "xs",
      "aria-hidden": "true"
    })
  }));
}; //InProgress Badge

var InProgressBadge = function (props) {
  var badgeClasses = clsx(styles["ppvx_badge--in-progress"], props.className);
  return /*#__PURE__*/React.createElement(BadgeComponent, _extends({}, props, {
    className: badgeClasses,
    icon: /*#__PURE__*/React.createElement(V2ClockIcon, {
      size: "xs",
      "aria-hidden": "true"
    })
  }));
}; //OnHold Badge

var OnHoldBadge = function (props) {
  var badgeClasses = clsx(styles["ppvx_badge--on-hold"], props.className);
  return /*#__PURE__*/React.createElement(BadgeComponent, _extends({}, props, {
    className: badgeClasses,
    icon: /*#__PURE__*/React.createElement(V2CriticalIcon, {
      size: "xs",
      "aria-hidden": "true"
    })
  }));
}; //Favorite Badge

var FavoriteBadge = function (props) {
  var badgeClasses = clsx(styles["ppvx_badge--favorite"], props.className);
  return /*#__PURE__*/React.createElement(BadgeComponent, _extends({}, props, {
    className: badgeClasses,
    icon: /*#__PURE__*/React.createElement(V2PreferredFilledIcon, {
      size: "xs",
      "aria-hidden": "true"
    })
  }));
}; //Numeric Badge

var NumericBadge = function (props) {
  //@ts-ignore
  var numericProp = parseInt(props.children, 10);
  var numericValue = numericProp < 10 ? numericProp : '9+';
  return /*#__PURE__*/React.createElement(BadgeComponent, _extends({}, props, {
    className: styles["ppvx_badge--numeric"]
  }), numericValue);
};

var BadgeComponent = function (_ref2) {
  var className = _ref2.className,
      children = _ref2.children,
      label = _ref2.label,
      icon = _ref2.icon,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  var v2BadgeClasses = clsx(styles.ppvx_badge, styles['ppvx--v2'], className);
  return /*#__PURE__*/React.createElement("span", _extends({
    className: v2BadgeClasses
  }, rest), icon, icon ? /*#__PURE__*/React.createElement("span", {
    className: styles["ppvx_badge__icon-label"]
  }, label) : children);
};

export { AuthorizedBadge, Badge, FavoriteBadge, InProgressBadge, NumericBadge, OnHoldBadge };
